import { postUser } from '../../services/api/user.api';
import { CREATE_USER_REQUEST, CREATE_USER_SUCCESS, CREATE_USER_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[CREATE_USER_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[CREATE_USER_SUCCESS](state) {
			state.isLoading = false;
		},
		[CREATE_USER_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async createUser({ commit }, params) {
			try {
				commit(CREATE_USER_REQUEST);
				await postUser(params);
				commit(CREATE_USER_SUCCESS);
			} catch (error) {
				commit(CREATE_USER_FAILURE, error);
			}
		},
	},
};